import moment from 'moment'

export const CalculateTimeInsured = (startDate: string, expireDate: string) => {
  let yearStart = moment(startDate).year()
  let exitStart = moment(expireDate).year()
  return (exitStart - yearStart).toString()
}

export const CalculateDateDiff = (startDate: string, expireDate: string) => {
  var startDateParse = moment(startDate, 'DD/MM/YYYY')
  var expireDateParse = moment(expireDate, 'DD/MM/YYYY')
  var duration = moment.duration(expireDateParse.diff(startDateParse));
  var days = duration.asDays();
  return days
}

export const CalculateSumPropertyInArray = (data: any, field: string) => {
  return data.reduce((a: any, b: any) => {
    return a + b[field]
  }, 0)
}